import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
    errorInfo: null
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error, errorInfo: null };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', backgroundColor: '#1a1208', color: '#fff', minHeight: '100vh', fontFamily: 'monospace' }}>
          <h1 style={{ color: '#ff4c4c' }}>Application Error</h1>
          <p>The application crashed. This is the ErrorBoundary catching it instead of showing a blank screen.</p>
          <div style={{ backgroundColor: 'rgba(255,0,0,0.1)', padding: '15px', borderRadius: '5px', marginTop: '10px' }}>
            <h3 style={{ margin: '0 0 10px 0', color: '#ff4c4c' }}>{this.state.error?.toString()}</h3>
            <pre style={{ overflowX: 'auto', whiteSpace: 'pre-wrap', color: '#ccc' }}>
              {this.state.errorInfo?.componentStack || this.state.error?.stack}
            </pre>
          </div>
          <button 
            onClick={() => window.location.reload()} 
            style={{ marginTop: '20px', padding: '10px 20px', backgroundColor: '#d4af37', border: 'none', color: '#1a1208', fontWeight: 'bold', cursor: 'pointer', borderRadius: '5px' }}>
            Reload Application
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
